import { render } from "./MainReview.vue?vue&type=template&id=73fd61d0&scoped=true"
import script from "./MainReview.vue?vue&type=script&lang=js"
export * from "./MainReview.vue?vue&type=script&lang=js"

import "./MainReview.vue?vue&type=style&index=0&id=73fd61d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fd61d0"]])

export default __exports__